import { createSlice } from '@reduxjs/toolkit';
import { getDoctorTypes, getTransportTypes, getUserFacilities } from '../../api/transports';

const initialState = {
  isLoading: false,
  error: null,
  data: { facilities: [], transportTypes: [], doctorTypes: [] },
};

const slice = createSlice({
  name: 'transports',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getFacilitiesSuccess(state, action) {
      state.isLoading = false;
      state.data.facilities = action.payload;
    },
    getTransportTypesSuccess(state, action) {
      state.isLoading = false;
      state.data.transportTypes = action.payload;
    },
    getDoctorTypesSuccess(state, action) {
      state.isLoading = false;
      state.data.doctorTypes = action.payload;
    },
  },
});

export default slice.reducer;

export function fetchTransportTypes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getTransportTypes();
      dispatch(slice.actions.getTransportTypesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function fetchDoctorTypes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getDoctorTypes();
      dispatch(slice.actions.getDoctorTypesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function fetchUserFacilities() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getUserFacilities();
      dispatch(slice.actions.getFacilitiesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
